import type { Testimonial } from "@/types/content";

export default function VoicesSection({ voices }: { voices: Testimonial[] }) {
  return (
    <section className="w-full border-b border-background-200 bg-background-50">
      <div className="mx-auto w-full max-w-[1240px] px-4 py-12 md:px-6 md:py-16">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <div className="max-w-2xl">
            <span className="font-label text-xs tracking-[0.28em] text-secondary-600">VOICES</span>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              读者怎么说
            </h2>
            <p className="mt-2 text-sm text-foreground-600">
              来自每天用瓜点追热点的读者反馈，记录他们真实的使用习惯。
            </p>
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {voices.map((v) => (
            <figure
              key={v.name}
              className="flex flex-col rounded-lg border border-background-200 bg-background-100 p-5"
            >
              <span className="flex h-8 w-8 items-center justify-center text-accent-600">
                <i className="ri-double-quotes-l text-2xl"></i>
              </span>
              <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">
                {v.content}
              </blockquote>
              <figcaption className="mt-4 flex items-center gap-3 border-t border-background-200 pt-4">
                <span className="flex h-9 w-9 items-center justify-center rounded-full bg-secondary-500 font-heading text-sm font-bold text-background-50">
                  {v.initial}
                </span>
                <span className="flex flex-col">
                  <span className="text-sm font-medium text-foreground-950">{v.name}</span>
                  <span className="text-xs text-foreground-500">{v.role}</span>
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}